import CommentView from '@ui/comments/comment-view';
import { elements } from '@ui/comments/comment-view';
import { siteModel } from 'models/SiteModel';

export default class extends CommentView {
  showDeletedMessage() {
    this.rootEl.addClass(elements.deleted.substr(1));
  }

  render() {
    this.rootEl.html(`
          <div class="c-comments__box">
            <div class="c-comments__content">
                <strong>Dziękujemy. Komentarz został zgłoszony do moderacji</strong>
            <a href="#">cofnij</a></div>
          </div>
    `);

    this.rootEl.find('a').on('click', (event) => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('ReportComment', {
        detail: {
          id: this.model.get('id'),
          isFlaggedByUser: this.model.get('isFlaggedByUser'),
        }
      }));
    });

    if (this.model.get('parentCommentId') === null) {
        this.buildRepliesView();
    }

  }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comments-views/flagged-comment-view.js